module.exports = __webpack_public_path__ + "static/media/logo-game.dcc4ba22.svg";